<template>
  <div>
    <div uk-alert class="uk-margin-small">
      <div class="uk-grid">
        <div class="uk-flex uk-flex-left uk-flex-middle uk-width-1-1">
          <span :uk-icon="icon"></span>
          <small>{{message}}</small>
        </div>
      </div>
      <div v-if="close">
        <a class="uk-alert-close" uk-close uk-dark></a>
      </div>
    </div>
  </div>
</template>
<script>
    export default {
      name: 'simpleAlert',
      props: ['icon', 'message', 'close']
    }
</script>

<style scoped>

</style>
